import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { useState } from "react";

function AgentSocialSummary(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [attended, setAttended] = useState(0);
    const [missed, setMissed] = useState(0);

    return (
        <div className={"card card-flush overflow-hidden widget-container widget-container"}>
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"> <FontAwesomeIcon icon={duotone("chart-network")} /> {t("socialsummary")}</span>
                </h3>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col> <span className="fs-3 fw-bold text-primary">{t("incomings")}</span></Col>
                    <Col> <span className="fs-3 fw-bold text-primary">{t("outgoings")}</span></Col>
                </Row>

                <Row>
                    <Col md={2} >
                        <div className="fs-2hx fw-bold text-gray-800">{(props.incoming.attendedToday + props.incoming.missedToday)}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col md={2}>
                        <div className="fs-2hx fw-bold text-success">{props.incoming.attendedToday}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col md={2}>
                        <div className="fs-2hx fw-bold text-danger">{props.incoming.missedToday}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>

                    <Col md={1}>
                        <div className="fs-2hx fw-bold text-gray-800">{props.outgoing.total}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col md={1}>
                        <div className="fs-2hx fw-bold text-warning">{props.outgoing.sent}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("sent")}</div>
                    </Col>
                    <Col md={1}>
                        <div className="fs-2hx fw-bold text-success">{props.outgoing.read}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("read")}</div>
                    </Col>
                    <Col md={1}>
                        <div className="fs-2hx fw-bold text-primary">{props.outgoing.delivered}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("delivered")}</div>
                    </Col>
                    <Col md={1}>
                        <div className="fs-2hx fw-bold text-danger">{props.outgoing.failed}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("failed")}</div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default AgentSocialSummary;